import React from 'react';
import { useNavigate } from 'react-router-dom';
import SessionExpirationModal from './SessionExpirationModal';

interface SessionExpirationModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container component for SessionExpirationModal that provides the navigation context
 * This component must be rendered inside a Router context
 */
const SessionExpirationModalContainer: React.FC<SessionExpirationModalContainerProps> = ({
  isOpen,
  onClose
}) => {
  const navigate = useNavigate();
  
  const handleNavigateToLogin = () => {
    navigate('/login');
  };
  
  return (
    <SessionExpirationModal
      isOpen={isOpen}
      onClose={onClose}
      onNavigateToLogin={handleNavigateToLogin}
    />
  );
};

export default SessionExpirationModalContainer;